import React from "react";
import { Link } from "react-router-dom";
import { cleanJoin } from "../../utils/stringUtil";
import "./DashboardItem.scss";

function DashboardItem({
  children,
  hasBorder = true,
  className,
  label,
  labelCounter,
  labelAlignment = "centered",
  labelBulmaColor = "black",
  labelSize = 2,
  labelCounterSize = 6,
  link,
  state,
  minHeight = "auto",
  ...rest
}) {
  return (
    <Link to={link} {...rest}>
      <div
        style={{ height: "180px" }}
        className={cleanJoin(
          "dashboard-item",
          "card",
          hasBorder ? "dashboard-item-has-border" : ""
        )}
      >
        <div className={cleanJoin("card-content", "has-text-centered", className)}>
          {label && (
            <div
              style={{
                minHeight: minHeight,
                maxHeight: minHeight,
              }}
              className={cleanJoin(
                `has-text-${labelAlignment}`,
                `is-size-${labelSize}`,
                `has-text-${labelBulmaColor}`,
                "overflow-y-hidden"
              )}
            >
              {label}
            </div>
          )}
          <div className={cleanJoin(`is-size-${labelCounterSize}`, "is-pulled-right")}>
            {labelCounter}
          </div>
          {children}
        </div>
      </div>
    </Link>
  );
}

export default DashboardItem;
